import { TagsInput as MantineTagsInput, TagsInputProps } from '@mantine/core';

export type ITagsInputProps = TagsInputProps;

/** @registry Design-layer pass-through over Mantine TagsInput for free-text entries (arbitrary values MultiSelect cannot accept); import this instead of @mantine/core TagsInput outside src/design. Extend here when TagsInput needs house behavior. */
export const TagsInput = MantineTagsInput;
